import React, { useState, useEffect } from 'react';
import { Alert, Col, Container, Row, Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import authApi from '../api/authApi';
import DataApi from '../api/DataApi';
import WatconnectApi from '../api/WatconnectApi';
import jwt_decode from 'jwt-decode';
import { preloadPermissions } from '../utils/permissionCache';
import {
  LoginSocialFacebook,
  LoginSocialGoogle,
  IResolveParams,
} from 'reactjs-social-login';

import {
  FacebookLoginButton,
  GoogleLoginButton,
} from 'react-social-login-buttons';

// Read redirect from URL only (e.g. from session timeout). Normal logout has no redirect param → go home.
const getRedirectFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const redirect =
    params.get('redirect') || params.get('redirect_uri') || '';
  if (!redirect || !redirect.startsWith('/')) return null;
  const excluded = ['/login', '/reset-password', '/google-auth-callback', '/402', '/403', '/404'];
  if (excluded.some(p => redirect === p || redirect.startsWith(p + '/'))) return null;
  return redirect;
};

const Login = () => {
  const watconnectApi = new WatconnectApi('auth');
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
    tcode: '',
  });
  const [show, setShow] = React.useState(false);
  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [sessionExpiredMessage, setSessionExpiredMessage] = useState(
    'You have been logged out. Please log in again.'
  );

  const [forgotPasswordData, setForgotPasswordData] = useState({
    username: '',
    tcode: ''
  });
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState('');
  const [forgotPasswordLoading, setForgotPasswordLoading] = useState(false);

  useEffect(() => {
    const reason = sessionStorage.getItem('logout_reason');
    const message = sessionStorage.getItem('logout_message');
    if (reason === 'SESSION_EXPIRED' || reason === 'IDLE_TIMEOUT') {
      setSessionExpiredMessage(
        message || 'You have been logged out. Please log in again.'
      );
      setShowSessionExpired(true);
      sessionStorage.removeItem('logout_reason');
      sessionStorage.removeItem('logout_message');
    }
  }, []);

  const [errorMessage, setErrorMessage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;



  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleSubmit = async e => {

    e.preventDefault();
    ////
    try {
      const result = await authApi.login(
        credentials.username,
        credentials.password,
        credentials.tcode
      );

      if (result.success) {
        //
        localStorage.setItem('token', result.authToken);
        setShowSessionExpired(false);
        // localStorage.removeItem('splashShown'); // Trigger splash screen on login - DISABLED
        const decodedToken = jwt_decode(result.authToken);

        // 🔒 CRITICAL: Store userinfo in sessionStorage for permission checks
        console.log('🔍 [Login] Decoded token:', decodedToken);
        sessionStorage.setItem('userinfo', JSON.stringify(decodedToken));
        console.log('✅ [Login] Stored userinfo in sessionStorage');

        // ✅ Set email to session or sessionStorage
        if (decodedToken.email) {
          sessionStorage.setItem('system_email', decodedToken.email); // you can also use sessionStorage
        }


        await authApi.fetchEntitlements();
        if (decodedToken.watconnect) {
          try {
            const watLoginResponse = await watconnectApi.login({
              email: decodedToken.watconnect.username,
              password: decodedToken.watconnect.password,
              tcode: decodedToken.watconnect.company_name,
            });
            if (watLoginResponse && watLoginResponse.success) {
              console.log('WatConnect login success ✅');

            } else {
              console.warn('WatConnect login failed ❌', watLoginResponse);
            }
          } catch (watError) {
            console.warn('WatConnect login error:', watError);
            // Don't block login if WatConnect fails
          }
        }

        try {
          //let notifications = await SparkApi.fetchSystemNotifications();
          //console.log('System Notifications:', notifications);

          //
          /*if (notifications) {
            //
            notifications.forEach(function (rec) {
              if (rec.type === 'SYSTEM_MAINTANANCE') {
                sessionStorage.setItem(
                  'notifications',
                  JSON.stringify(notifications)
                );

                return;
              }
            });
          } else {
            sessionStorage.removeItem('notifications');
          }*/
        } catch (notifError) {
          console.warn('Failed to fetch notifications:', notifError);
          // Don't block login if notifications fail
        }


        sessionStorage.setItem('selectedWhatsAppSetting', '');

        // 🔒 PRELOAD PERMISSIONS: Cache user permissions on login
        preloadPermissions().catch(err => {
          console.warn('Failed to preload permissions:', err);
          // Don't block login if permission preload fails
        });

        window.dispatchEvent(new Event('ibs-auth-login'));
        // Redirect from URL param only (session timeout); no param → home (e.g. after normal logout)
        const redirectUrl = getRedirectFromUrl();
        navigate(redirectUrl || '/');
      } else {
        setShow(true);
        setErrorMessage(result.errors);
      }
    } catch (error) {
      console.error('Login error:', error);
      setShow(true);
      setErrorMessage('An error occurred during login. Please try again.');
    }
  };

  const handleForgotPasswordChange = e => {
    setForgotPasswordData({ ...forgotPasswordData, [e.target.name]: e.target.value });
  };
  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    setForgotPasswordLoading(true);
    setForgotPasswordMessage('');

    try {
      const result = await authApi.forgotPassword(
        forgotPasswordData.username,
        forgotPasswordData.tcode
      );

      if (result.success) {
        setForgotPasswordMessage('Reset link sent! Please check your email.');
        // Optional: clear form
        setForgotPasswordData({ username: '', tcode: '' });
      } else {
        setForgotPasswordMessage(result.message || 'Failed to send reset link. Please try again.');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      setForgotPasswordMessage('An error occurred. Please try again.');
    } finally {
      setForgotPasswordLoading(false);
    }
  };

  const handleChange = e => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    //
  }, []);
  const handleSocialLogin = async response => {
    //
    //

    const result = await authApi.social_login(response, response.access_token);
    if (result.success) {
      //
      localStorage.setItem('token', result.authToken);
      // localStorage.removeItem('splashShown'); // Trigger splash screen on login - DISABLED

      // 🔒 CRITICAL: Store userinfo in sessionStorage for permission checks
      const decodedToken = jwt_decode(result.authToken);
      console.log('🔍 [Social Login] Decoded token:', decodedToken);
      sessionStorage.setItem('userinfo', JSON.stringify(decodedToken));
      console.log('✅ [Social Login] Stored userinfo in sessionStorage');



      setTimeout(async function () {
        const notificationsApi = new DataApi('common');
        const notificationsResponse = await notificationsApi.get('/notifications');
        const notifications = notificationsResponse?.data || null;
        //
        if (notifications) {
          //
          notifications.forEach(function (rec) {
            if (rec.type === 'SYSTEM_MAINTANANCE') {
              sessionStorage.setItem(
                'notifications',
                JSON.stringify(notifications)
              );

              return;
            }
          });
        } else {
          sessionStorage.removeItem('notifications');
        }
      }, 1000);




      // 🔒 PRELOAD PERMISSIONS: Cache user permissions on login
      preloadPermissions().catch(err => {
        console.warn('Failed to preload permissions:', err);
        // Don't block login if permission preload fails
      });

      window.dispatchEvent(new Event('ibs-auth-login'));
      // Redirect from URL param only (session timeout); no param → home (e.g. after normal logout)
      const redirectUrl = getRedirectFromUrl();
      navigate(redirectUrl || '/');
    } else {
      setShow(true);
      setErrorMessage(result.errors);
    }
  };

  const isFormValid =
    Boolean(credentials.password?.trim()) &&
    Boolean(credentials.username?.trim()) &&
    Boolean(credentials.tcode?.trim());
  return (
    <Container>
      <Modal
        show={showSessionExpired}
        onHide={() => setShowSessionExpired(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>User session expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>{sessionExpiredMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowSessionExpired(false)}>
            Login
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showForgotPassword}
        onHide={() => { setShowForgotPassword(false); setForgotPasswordMessage(''); }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Enter your username and company name to reset your password.</p>
          <Form onSubmit={handleForgotPasswordSubmit}>
            <Form.Group className='mb-3'>
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                required
                type='text'
                name='tcode'
                onChange={handleForgotPasswordChange}
                placeholder='Enter your company name'
                value={forgotPasswordData.tcode}
              />
            </Form.Group>
            <Form.Group className='mb-3'>
              <Form.Label>Username</Form.Label>
              <Form.Control
                required
                type='text'
                name='username'
                onChange={handleForgotPasswordChange}
                placeholder='Enter your username'
                value={forgotPasswordData.username}
              />
            </Form.Group>
            {forgotPasswordMessage && (
              <Alert variant={forgotPasswordMessage.includes('error') ? 'danger' : 'info'}>
                {forgotPasswordMessage}
              </Alert>
            )}
            <div className='d-flex justify-content-end'>
              <Button variant='secondary' onClick={() => { setShowForgotPassword(false); setForgotPasswordMessage(''); }}>
                Cancel
              </Button>
              <Button variant='primary' type='submit' disabled={forgotPasswordLoading} className='ms-2'>
                {forgotPasswordLoading ? 'Sending...' : 'Send Reset Link'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      <Row className='login-form p-3 mt-5 overflow-auto'>
        <Col lg={6} className='pt-5'>
          <img src='/login.jpg' alt='' style={{ width: '100%' }} />
        </Col>
        <Col lg={6} className='login-section'>
          <center></center>
          <div className='p-5 pt-4'>
            <Form onSubmit={handleSubmit}>
              <div className='mt-2 text-center mb-3'>
                <img
                  src='/vgrow-logo.jpg'
                  alt='vGrow'
                  style={{ width: '120px' }}
                  className='mb-2'
                />
                <div>Convert, before it fades away</div>
                <h3 className='my-2 mt-5'>Login</h3>
              </div>
              <Alert variant='danger' show={show} className='error-alert'>
                {errorMessage}
              </Alert>
              <Form.Group className='mb-3'>
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  required
                  style={{ height: '36px' }}
                  type='text'
                  name='tcode'
                  onChange={handleChange}
                  placeholder='Enter your company name'
                  value={credentials.tcode}
                  autoComplete='code'
                />
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicEmail'>
                <Form.Label>Username</Form.Label>
                <Form.Control
                  required
                  style={{ height: '36px' }}
                  type='text'
                  name='username'
                  onChange={handleChange}
                  placeholder='Enter username'
                  value={credentials.username}
                />
              </Form.Group>
              <Form.Group className='mb-3' controlId='formBasicPassword'>
                <Form.Label>Password</Form.Label>
                <div className='d-flex align-items-center position-relative'>
                  <Form.Control
                    required
                    style={{ height: '36px' }}
                    type={showPassword ? 'text' : 'password'}
                    name='password'
                    onChange={handleChange}
                    placeholder='Enter your password'
                    value={credentials.password}
                    autoComplete='current-password'
                  />
                  <span
                    className='position-absolute end-0 me-3'
                    onClick={togglePasswordVisibility}
                    style={{ cursor: 'pointer' }}
                  >
                    <i
                      className={`fa ${!showPassword ? 'fa-eye-slash' : 'fa-eye'} text-secondary`}
                      aria-hidden='true'
                    ></i>
                  </span>
                </div>
              </Form.Group>
              <div className='d-flex align-items-center justify-content-between mt-3'>
                <Button variant='primary' type='submit' className="px-4">
                  Login
                </Button>
                <a
                  href='#'
                  onClick={e => {
                    e.preventDefault();
                    setShowForgotPassword(true);
                  }}
                  style={{
                    color: '#006DCC',
                    textDecoration: 'none',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                >
                  Forgot Password?
                </a>
              </div>
            </Form>
            <div className='pt-4 text-center'>
              {/* or Login with */}
              <div className='pt-4'>
                <a href='#'>
                  <span class='fa-stack fa-2x'>
                    <i
                      class='fa-solid fa-circle fa-stack-2x'
                      style={{ color: '#3b5998', fontSize: '4rem' }}
                    ></i>
                    <i
                      class='fa-brands fa-facebook-f fa-stack-1x'
                      style={{ color: '#fff', fontSize: '2rem' }}
                    ></i>
                  </span>
                </a>
                <a href='#'>
                  <span class='fa-stack fa-2x'>
                    <i
                      class='fa-solid fa-circle fa-stack-2x'
                      style={{ color: 'tomato', fontSize: '4rem' }}
                    ></i>
                    <i
                      class='fa-brands fa-google fa-stack-1x'
                      style={{ color: '#fff', fontSize: '2rem' }}
                    ></i>
                  </span>
                </a>
                <a href='#'>
                  <span class='fa-stack fa-2x'>
                    <i
                      class='fa-solid fa-circle fa-stack-2x'
                      style={{ color: '#0d95e8', fontSize: '4rem' }}
                    ></i>
                    <i
                      class='fa-brands fa-twitter fa-stack-1x'
                      style={{ color: '#fff', fontSize: '2rem' }}
                    ></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <div className='text-center'>
        <h6 className='text-center mt-3'> Powered by</h6>
        <a href="https://vgrowcrm.com/" style={{ color: "#0176d3", textDecoration: "none", fontWeight: "600", margin: "0 4px", fontSize: "26px" }}>vGrowCRM</a>
      </div>
    </Container>
  );
};

export default Login;
